// extracted by mini-css-extract-plugin
module.exports = {"label":"ProjectCustomerInfoTab_label__2saVy","value":"ProjectCustomerInfoTab_value__3z9WN"};